module.exports = {
  languageToUrlCodeMap: {
    HINDI: 'hi',
    ENGLISH: 'en'
  },
  languageToTemplateIdMap: {
    1: 'ROUTE_ENGLISH',
    2: 'STATION_ENGLISH',
    3: 'CITY_ENGLISH',
    4: 'TRAIN_ENGLISH',
    5: 'ROUTE_HINDI',
    6: 'STATION_HINDI',
    8: 'TRAIN_HINDI',
    10: 'TYPE_ENGLISH'
  },
  ENGLISH: 'ENGLISH',
  getRouteTemplateId: (lang = 1) => {
    return module.exports.languageToUrlCodeMap[module.exports.languageToTemplateIdMap[lang].split('_')[1]];
  }
};
